//@ts-check
import React, { useEffect } from 'react';
import FrameBase from '../FrameBase';
import crossDocumentProtocol from '../../frame/FrameBase/crossDocumentProtocol';
/**@param {import('./types').ContactPreviewFrameProps} props */

var ContactPreview = function ContactPreview(_ref) {
  var id = _ref.id,
      width = _ref.width,
      height = _ref.height,
      returnUrl = _ref.returnUrl,
      onClose = _ref.onClose;
  if (!returnUrl) returnUrl = 'message-close-editor';
  useEffect(function () {
    var handleClose = function handleClose() {
      if (onClose) onClose();
    };

    crossDocumentProtocol.on('close-editor', handleClose);
    return function cleanup() {
      crossDocumentProtocol.off('close-editor', handleClose);
    };
  }, [onClose]);
  var url = 'embed/ContactPreview?returnUrl=message-close-editor/#Contacts/' + id;

  var onEvent = function onEvent(event) {
    switch (event.action) {
      default:
        break;
    }
  };

  return React.createElement(FrameBase, {
    useEcrionServer: true,
    url: url,
    width: width,
    height: height,
    namespace: "Contact",
    on: onEvent,
    style: {
      minHeight: 600
    }
  });
};

ContactPreview.defaultProps = {
  width: '100%',
  // extra vertical 5px from iframe
  height: 'calc(100vh - 5px)',
  returnUrl: ''
};
export default ContactPreview;